import { storyblokEditable } from '@storyblok/react';
import { FC } from 'react';
import { MagazineTeaserStoryblok } from 'storyblok-types';
import { Image } from 'atoms/Image/Image';
import { Link } from 'atoms/Link/Link';
import { P } from 'atoms/Typography';
import { IServerProps } from 'pages/StoryBlok/types';
import { getStoryblokUrl } from 'commerce/storyblok/utils';
import styles from 'src/client/components/pages/StoryBlok/MagazineTeasers/styles.module.css';

export const MagazineTeaser: FC<{
  blok: MagazineTeaserStoryblok;
  serverProps: IServerProps;
}> = ({ blok }) => {
  const url = getStoryblokUrl(blok?.link);

  return (
    <div className={styles.teaser} {...storyblokEditable(blok)}>
      <Link href={url} className={styles.link}>
        <Image
          className={styles.img}
          src={blok?.image?.filename}
          alt={blok?.image?.alt}
        />
        <div
          className={styles.textBlock}
          style={{ backgroundColor: blok?.background }}
        >
          <P className={styles.title}>{blok.headline}</P>
          <P className={styles.text}>{blok.date}</P>
        </div>
      </Link>
    </div>
  );
};
